"use client";

import { useEffect } from "react";
import { useTranslations } from "next-intl";

const COPY_SVG =
  '<svg class="octicon octicon-copy" viewBox="0 0 16 16" width="14" height="14" fill="currentColor" aria-hidden="true"><path d="M0 6.75C0 5.784.784 5 1.75 5h1.5a.75.75 0 0 1 0 1.5h-1.5a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-1.5a.75.75 0 0 1 1.5 0v1.5A1.75 1.75 0 0 1 9.25 16h-7.5A1.75 1.75 0 0 1 0 14.25Z"></path><path d="M5 1.75C5 .784 5.784 0 6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0 1 14.25 11h-7.5A1.75 1.75 0 0 1 5 9.25Zm1.75-.25a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25Z"></path></svg>';
const CHECK_SVG =
  '<svg class="octicon octicon-check" viewBox="0 0 16 16" width="14" height="14" fill="currentColor" aria-hidden="true"><path d="M13.78 4.22a.75.75 0 0 1 0 1.06l-7.25 7.25a.75.75 0 0 1-1.06 0L1.72 8.78a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018L6 10.94l6.72-6.72a.75.75 0 0 1 1.06 0Z"></path></svg>';

export default function CodeCopyRuntime() {
  const copyLabel = useTranslations("site.code")("copy");

  useEffect(() => {
    const pres = Array.from(
      document.querySelectorAll<HTMLElement>(".wmde-markdown pre"),
    );
    const cleanups: (() => void)[] = [];

    for (const pre of pres) {
      const code = pre.querySelector("code");
      if (!code || pre.querySelector(".copied")) continue;

      const button = document.createElement("div");
      button.className = "copied";
      button.setAttribute("role", "button");
      button.setAttribute("aria-label", copyLabel);
      button.innerHTML = COPY_SVG + CHECK_SVG;

      let timer: ReturnType<typeof setTimeout> | undefined;
      const onClick = () => {
        const text = code.textContent ?? "";
        void navigator.clipboard
          ?.writeText(text)
          .then(() => {
            button.classList.add("active");
            clearTimeout(timer);
            timer = setTimeout(() => button.classList.remove("active"), 2000);
          })
          .catch(() => {
            // 复制失败静默
          });
      };

      button.addEventListener("click", onClick);
      pre.appendChild(button);
      cleanups.push(() => {
        clearTimeout(timer);
        button.removeEventListener("click", onClick);
        button.remove();
      });
    }

    return () => cleanups.forEach((fn) => fn());
  }, [copyLabel]);

  return null;
}
